// SIMPLE HASH CHANGE
ui.paging('#simpleHash', { total: 99 });
// CUSTOM HASH
ui.paging('#customHash', { total: 20, url: '#my-custom-hash=' });
// SIMPLE URL CHANGE
ui.paging('#simpleUrlChange', { total: 13, url: '?page=' });
// COMPLEX URL CHANGE
ui.paging('#complexUrlChange',
	{ current: 3,
		total: 90,
		previousUrl: '/?results=100',
		nextUrl: '/?results=200',
		onChange(page) {
			window.location = `/?results=${page * 50}`;
		}
	});
// PAGING WITH RIGHT ALIGNMENT
ui.paging('#pagingRight', { total: 61 });
function getParameterByName(name) {
	const newname = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
	const regex = new RegExp(`[\\?&]${newname}=([^&#]*)`);
	const results = regex.exec(window.location.search);
	return results === null ? '' : parseInt(decodeURIComponent(results[1].replace(/\+/g, ' ')), 10);
}
function loremGenerator(length) {
	let	result = '';
	let lorem = 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab eveniet aliquam nihil expedita dolore quasi nulla aspernatur debitis rerum tenetur aperiam itaque ipsum ea, laboriosam quae, illo natus reprehenderit adipisci! Maxime voluptate quas iste, non aspernatur eum nam aliquid eveniet sint, iusto accusamus eligendi possimus ea atque minus perspiciatis, reiciendis fugit quia facere, incidunt voluptatibus quae quod consequuntur. Quod, accusantium. Quo incidunt, laudantium sunt iusto architecto, voluptatum, officia porro in, aperiam possimus voluptates earum eligendi illum consequatur cumque quas ipsam quidem eos. Excepturi ut veniam quo tempora ratione. Ab, maxime! Magnam atque ex architecto iure iste dignissimos odio totam, natus quam praesentium excepturi delectus adipisci optio veniam voluptatem? Cum numquam et sit consectetur eius vel veniam impedit molestiae recusandae fugiat! Inventore expedita numquam vero iusto aut maxime facilis optio, sunt quaerat ipsa, omnis sequi quis porro officia! Earum voluptate at repellendus molestias vel deleniti, debitis autem, deserunt qui, cumque, pariatur. Fugiat itaque, illo maiores fugit, commodi voluptatem harum libero rem impedit quia neque nemo atque veritatis accusantium asperiores, et, minima eveniet temporibus est. Ducimus maxime beatae perferendis ipsam laborum ad! Incidunt quos perferendis accusamus, molestiae similique ut voluptate suscipit tenetur distinctio. Repellendus cupiditate laudantium at quod illo itaque quia id dignissimos. Veniam nobis, at. Reprehenderit ipsum quo delectus iusto quasi? Quisquam, doloremque, aut. Rem aliquam tempora facere sapiente assumenda. Ipsam eaque quisquam deleniti esse officia voluptates iusto perspiciatis tenetur amet aliquam in eligendi consectetur nostrum ea porro, quod reiciendis nobis. Id, nemo soluta. Inventore impedit quis distinctio facere nesciunt, neque ipsum, odio eos reprehenderit nisi iste tempore perspiciatis, corporis voluptatibus consequatur obcaecati, necessitatibus voluptates quibusdam incidunt fugit. Corporis nesciunt, ipsum. Maiores nemo molestiae veniam, aliquid, perferendis qui ullam quibusdam ab necessitatibus expedita nesciunt laboriosam, officiis, facere amet dolor enim. Beatae cumque architecto eaque saepe, maiores consectetur, distinctio aperiam illo possimus.';
	lorem = lorem.split(' ');
	const loremLength = lorem.length;
	for (let i = 0; i < length; i += 1) {
		const words = lorem[Math.floor(Math.random() * loremLength)];
		result += result === '' ? words : ` ${words}`;
	}
	return result[0].toUpperCase() + result.slice(1).toLowerCase();
}
function generateContent(el, page, pagingPer, preHeader) {
	const displayed = parseInt(pagingPer, 10) || 5;
	const startNum = ((page * displayed) - displayed) + 1;
	const fragment = document.createDocumentFragment();
	while (el.firstChild) {
		el.removeChild(el.firstChild);
	}
	for (let i = startNum; i < (startNum + displayed); i += 1) {
		const row = document.createElement('tr');
		row.innerHTML = `<td headers="${preHeader}Id" data-label="id"><strong>${i}</strong></td><td headers="${preHeader}Lorem" data-label="lorem">${loremGenerator(5)}</td>`;
		fragment.appendChild(row);
	}
	el.appendChild(fragment);
}
const tableBody = document.getElementById('combinedContents').querySelector('tbody');
generateContent(tableBody, parseInt(window.location.hash.split('bound-page=')[1], 10) || 1, null, 'hash');
// TWO SETS OF (HASH ONLY URL CHANGE) PAGINATION COMPONENTS BOUND TOGETHER WITH CALLBACK
ui.paging('.dualPaging', {
	total: 4,
	url: '#bound-page=',
	current: 1,
	onChange(page) {
		/* Update the displayed data */
		generateContent(tableBody, page, null, 'hash');
		return true;
	}
});
function updateQueryStringParameter(uri, key, value) {
	const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
	const separator = uri.indexOf('?') !== -1 ? '&' : '?';
	if (uri.match(re)) {
		return uri.replace(re, `$1${key}=${value}$2`);
	}
	return `${uri}${separator}${key}=${value}`;
}
const resultsPerPage = document.getElementById('resultsPerPage');
const pagePer = window.sessionStorage.pagePer || resultsPerPage.value;
resultsPerPage.value = pagePer;
generateContent(document.getElementById('domUrlPattern').querySelector('tbody'), parseInt(getParameterByName('page'), 10) || 1, pagePer, 'dom');
// update the per page field
resultsPerPage.addEventListener('change', () => {
	window.sessionStorage.pagePer = resultsPerPage.value;
	// Go back to page 1
	window.location = updateQueryStringParameter(window.location.href.split('#')[0], 'page', 1);
});
/* Server Pagination Creating the Dom with Url Pattern */
ui.paging('#urlChangeExample-1', {
	current: getParameterByName('page') || 1,
	total: 30 / window.sessionStorage.pagePer || 6,
	url: '?page=',
	onChange() {
		const pagingPer = window.sessionStorage.pagePer || resultsPerPage.value;
		const pageQuery = getParameterByName('page');
		generateContent(document.getElementById('domUrlPattern').querySelector('tbody'), pageQuery, pagingPer, 'js');
		return true;
	}
});



// WEBPACK FOOTER //
// ./src/components/paging/paging.demo.js